import BaseListPresenter from "../../../base/BaseListPresenter";
import { getCurrentUserUseCase } from "../../../usecases/user";

class SalesDiscountAmountPresenter extends BaseListPresenter {
  init() {
    this.store = [];
    // this.limit = 2000000;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterStore = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async findObjects() {
    try {
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = {
        include: ["all"],
        where: { email: user.email },
      };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);
      const store = this.store[0].storeAnalytic.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0; // names must be equal
      });
      this.view.setStore(store);
    } catch (error) {
      console.error("Error fetching user or store data:", error);
      return;
    }

    const skip = (this.current - 1) * this.limit;
    const storeCodes = this.store?.flatMap((storeItem) =>
      storeItem.storeAnalytic?.map((analytic) => analytic?.name)
    );

    const query = {
      // limit: this.limit,
      skip: skip,
      where: {
        store_code:
          this.filterStore === "AllStore" ? storeCodes : this.filterStore,
        tran_date: this.filterDate && this.filterDate,
      },
      include: ["all"],
      sort: this.sort,
      keys: [
        "store_code",
        "tran_date",
        "total",
        "total_taxfree",
        "total_tax",
        "discount_amount",
        "createdAt",
        "status",
        // "items",
      ],
    };

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where: query.where }
      );

      this.count = count;
      console.log("this.count", this.count);
      this.view.setCount(this.count);

      let timeoutId = null;

      // Handle delayed "not found"
      if (this.count === 0) {
        timeoutId = setTimeout(() => {
          if (this.count === 0) {
            this.view.setNotFound(true);
            this.view.setObjects([]);
            this.view.setTotal(0);
          }
        }, 15000); // 15 seconds delay
      }

      // Batching logic
      let buffer = [];

      const flushBuffer = () => {
        if (buffer.length > 0) {
          this.view.setState((prevState) => ({
            objects: [...prevState.objects, ...buffer],
          }));
          this.objects = this.objects.concat(buffer);
          this.view.setTotal(this.objects.length);
          this.view.setObjects(this.objects);
          buffer = [];
        }
      };

      const onData = (objects) => {
        if (objects.length > 0 && timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
          this.view.setNotFound(false);
        }
        buffer.push(...objects);
      };

      const flushInterval = setInterval(flushBuffer, 2000);

      await this.findObjectUseCase.execute(
        this.view.getCollectionName(),
        query,
        {
          timeout: 100000,
          onData,
        }
      );

      clearInterval(flushInterval);
      flushBuffer();
      // const objects = await this.findObjectUseCase.execute(
      //   this.view.getCollectionName(),
      //   query
      // );
      // this.objects = this.objects.concat(objects);
      // this.view.setTotal(this.objects.length);
      // this.view.setObjects(this.objects);
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  onChangeStore(where) {
    this.filterStore = where;
    this.getObjects();
  }

  onChangeDate(where) {
    const pad = (num, size = 2) => String(num).padStart(size, "0");
    const formatUTC = (d) => {
      return (
        [
          d.getUTCFullYear(),
          pad(d.getUTCMonth() + 1),
          pad(d.getUTCDate()),
        ].join("-") +
        " " +
        [
          pad(d.getUTCHours()),
          pad(d.getUTCMinutes()),
          pad(d.getUTCSeconds()),
        ].join(":") +
        "." +
        pad(d.getUTCMilliseconds(), 3)
      );
    };

    if (where && typeof where === "object") {
      ["$gte", "$lte"].forEach((key) => {
        const raw = where[key];
        if (typeof raw === "string") {
          const d = new Date(raw);
          if (!isNaN(d.getTime())) {
            if (key === "$lte") {
              d.setUTCDate(d.getUTCDate() + 1);
            }

            where[key] = formatUTC(d);
          } else {
            console.error(`Invalid date for ${key}:`, raw);
            delete where[key];
          }
        }
      });
    }

    if (where !== "AllMonths" && where) {
      this.filterDate = where;
    } else {
      delete this.filterDate;
    }

    this.getObjects();
  }
}

export default SalesDiscountAmountPresenter;
